/// <reference path="../../Common/Helpers/GridEditorBase.ts" />

namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ContraDetailEditor extends _Ext.GridEditorBase<PaymentDetailsRow> {
        protected getColumnsKey() { return "Finance.ContraDetail"; }
        protected getDialogType() { return ContraDetailDialog; }
        protected getLocalTextPrefix() { return ContraDetailRow.localTextPrefix; }
        exchangerate: number;
        rateid: string;
        constructor(container: JQuery) {
            super(container); 
        }

        
        validateEntity(row, id) {
            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.LedgerId === row.LedgerId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Ledger is already in order details!');
                return false;
            }

            row.LedgerName = OMS.AccountLedgerRow.getLookup().itemById[row.LedgerId].LedgerName;
            //row.LineTotal = (row.Quantity || 0) * (row.UnitPrice || 0) - (row.Discount || 0);
            return true;
        }

        

    }
}